/* POWDER FASHION — ALPINE LAYER — alpine.js
   Snowfall, parallax mountains, après-ski scenes and 3D tilt cards.
   Everything degrades gracefully: no JS = static page, reduced motion = no animation. */
(function () {
  "use strict";
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var finePointer = window.matchMedia("(hover: hover) and (pointer: fine)").matches;

  /* ============ 1. Snowfall (hero only, lightweight canvas) ============ */
  var snowCanvas = document.querySelector("[data-snow]");
  if (snowCanvas && !reduced) {
    var ctx = snowCanvas.getContext("2d");
    var flakes = [], W = 0, H = 0, dpr = Math.min(window.devicePixelRatio || 1, 2);
    var COUNT = window.innerWidth < 760 ? 40 : 90;

    function resize() {
      var r = snowCanvas.parentElement.getBoundingClientRect();
      W = r.width; H = r.height;
      snowCanvas.width = W * dpr; snowCanvas.height = H * dpr;
      snowCanvas.style.width = W + "px"; snowCanvas.style.height = H + "px";
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function spawn(f, fresh) {
      f.x = Math.random() * W;
      f.y = fresh ? Math.random() * H : -10;
      f.r = 0.8 + Math.random() * 2.4;          // radius
      f.d = 0.3 + Math.random() * 0.9;          // depth → speed & alpha
      f.vx = (Math.random() - 0.5) * 0.18;
      f.ph = Math.random() * Math.PI * 2;        // sway phase
      return f;
    }
    resize();
    for (var i = 0; i < COUNT; i++) flakes.push(spawn({}, true));
    window.addEventListener("resize", resize);

    var last = 0, visible = true;
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(snowCanvas);
    }
    function tick(ts) {
      requestAnimationFrame(tick);
      if (!visible) return;
      var dt = Math.min((ts - last) / 16.7, 3); last = ts;
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < flakes.length; i++) {
        var f = flakes[i];
        f.ph += 0.006 * dt;
        f.y += (0.14 + f.d * 0.34) * dt;
        f.x += f.vx * dt + Math.sin(f.ph) * 0.16;
        if (f.y > H + 10 || f.x < -10 || f.x > W + 10) spawn(f, false);
        ctx.beginPath();
        ctx.arc(f.x, f.y, f.r * f.d + 0.4, 0, Math.PI * 2);
        ctx.fillStyle = "rgba(255,255,255," + (0.35 + f.d * 0.55) + ")";
        ctx.fill();
      }
    }
    requestAnimationFrame(tick);
  }

  /* ============ 2. Parallax mountains + sun (scroll & mouse) ============ */
  var hero = document.querySelector(".ed-hero");
  var layers = hero ? [].slice.call(hero.querySelectorAll("[data-depth]")) : [];
  if (hero && layers.length && !reduced) {
    var mx = 0, my = 0, sy = 0, ticking = false;
    function apply() {
      ticking = false;
      layers.forEach(function (el) {
        var d = parseFloat(el.getAttribute("data-depth")) || 0;
        var x = mx * d * 40;
        var y = sy * d * 0.35 + my * d * 20;
        el.style.transform = (el.classList.contains("alp-mountains__layer") ? "translateX(-50%) " : "") +
          "translate3d(" + x.toFixed(1) + "px," + y.toFixed(1) + "px,0)";
      });
    }
    function req() { if (!ticking) { ticking = true; requestAnimationFrame(apply); } }
    window.addEventListener("scroll", function () {
      var r = hero.getBoundingClientRect();
      sy = Math.max(0, -r.top);
      if (r.bottom > 0) req();
    }, { passive: true });
    if (finePointer) {
      hero.addEventListener("pointermove", function (e) {
        var r = hero.getBoundingClientRect();
        mx = (e.clientX - r.left) / r.width - 0.5;
        my = (e.clientY - r.top) / r.height - 0.5;
        req();
      });
      hero.addEventListener("pointerleave", function () { mx = 0; my = 0; req(); });
    }
    apply();
  }

  /* ============ 3. Scenes in dark sections (data-scene="lift|snow|lights|stars") ============ */
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html) e.innerHTML = html; return e; }
  var CABIN = '<svg viewBox="0 0 40 62"><g class="swing">' +
    '<rect x="17" y="0" width="6" height="6" rx="1.5" fill="#d9e2ee"/>' +
    '<line class="arm" x1="20" y1="6" x2="20" y2="22" stroke-width="2.4" stroke-linecap="round"/>' +
    '<rect class="body BODY" x="4" y="22" width="32" height="34" rx="7"/>' +
    '<rect class="win" x="9" y="28" width="22" height="13" rx="3"/>' +
    '<rect x="19" y="28" width="2" height="13" fill="#f7f9fc" opacity="0.6"/>' +
    '<rect x="4" y="50" width="32" height="6" rx="3" fill="#0e1b4d" opacity="0.18"/>' +
    '</g></svg>';

  function makeSnow(canvas, count) {
    var ctx = canvas.getContext("2d"), flakes = [], W = 0, H = 0, dpr = Math.min(window.devicePixelRatio || 1, 2);
    function resize() {
      var r = canvas.parentElement.getBoundingClientRect(); W = r.width; H = r.height;
      canvas.width = W * dpr; canvas.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function spawn(f, fresh) { f.x = Math.random() * W; f.y = fresh ? Math.random() * H : -10; f.r = 0.8 + Math.random() * 2.4; f.d = 0.3 + Math.random() * 0.9; f.vx = (Math.random() - 0.5) * 0.18; f.ph = Math.random() * Math.PI * 2; return f; }
    resize(); for (var i = 0; i < count; i++) flakes.push(spawn({}, true));
    window.addEventListener("resize", resize);
    var last = 0, visible = true;
    if ("IntersectionObserver" in window) new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(canvas);
    (function tick(ts) {
      requestAnimationFrame(tick); if (!visible) return;
      var dt = Math.min((ts - last) / 16.7, 3); last = ts; ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < flakes.length; i++) {
        var f = flakes[i]; f.ph += 0.006 * dt; f.y += (0.14 + f.d * 0.34) * dt; f.x += f.vx * dt + Math.sin(f.ph) * 0.16;
        if (f.y > H + 10 || f.x < -10 || f.x > W + 10) spawn(f, false);
        ctx.beginPath(); ctx.arc(f.x, f.y, f.r * f.d + 0.4, 0, Math.PI * 2);
        ctx.fillStyle = "rgba(255,255,255," + (0.35 + f.d * 0.55) + ")"; ctx.fill();
      }
    })(0);
  }

  var scenes = {
    lift: function (host) {
      var sc = el("div", "scene scene--lift");
      var cable = el("div", "cable"), track = el("div", "track");
      var n = window.innerWidth < 760 ? 3 : 5;
      for (var i = 0; i < n; i++) {
        var c = el("div", "cabin", CABIN.replace("BODY", i % 2 === 1 ? "body--sun" : ""));
        c.style.setProperty("--dur", "110s");
        c.style.setProperty("--delay", (-(i / n) * 110).toFixed(1) + "s");
        c.style.setProperty("--sw", (-Math.random() * 3.6).toFixed(1) + "s");
        track.appendChild(c);
      }
      sc.appendChild(cable); sc.appendChild(track);
      host.insertBefore(sc, host.firstChild);
    },
    snow: function (host) {
      var sc = el("div", "scene scene--snow");
      var canvas = document.createElement("canvas");
      sc.appendChild(el("div", "moon")); sc.appendChild(canvas); sc.appendChild(el("div", "trees"));
      host.insertBefore(sc, host.firstChild);
      if (!reduced) makeSnow(canvas, window.innerWidth < 760 ? 35 : 70);
    },
    lights: function (host) {
      var sc = el("div", "scene scene--lights");
      var w = host.clientWidth || window.innerWidth;
      var swags = w < 760 ? 2 : 4, per = w < 760 ? 6 : 9;
      var sag = 70, top = 14;
      var d = "M0 " + top;
      for (var s = 0; s < swags; s++) {
        var x0 = (s / swags) * w, x1 = ((s + 1) / swags) * w;
        d += " Q " + ((x0 + x1) / 2) + " " + (top + sag * 2) + " " + x1 + " " + top;
      }
      var svg = '<svg class="wire" viewBox="0 0 ' + w + ' 120" preserveAspectRatio="none"><path d="' + d + '"/></svg>';
      sc.innerHTML = svg;
      var kinds = ["", "bulb--warm", "", "bulb--white", ""];
      for (var s2 = 0; s2 < swags; s2++) {
        for (var k = 1; k <= per; k++) {
          var t = k / (per + 1);
          var x = ((s2 + t) / swags) * 100;
          var y = top + 4 * sag * t * (1 - t);   /* quadratic bezier at parameter t */
          var b = el("span", "bulb " + kinds[(s2 * per + k) % kinds.length]);
          b.style.setProperty("--x", x.toFixed(2) + "%");
          b.style.setProperty("--y", y.toFixed(1) + "px");
          b.style.setProperty("--tw", (2.2 + Math.random() * 2.5).toFixed(1) + "s");
          b.style.setProperty("--delay", (-Math.random() * 4).toFixed(1) + "s");
          sc.appendChild(b);
        }
      }
      host.insertBefore(sc, host.firstChild);
    },
    sunset: function (host) {
      var sc = el("div", "scene scene--sunset");
      sc.innerHTML =
        '<div class="sunset-haze"></div>' +
        '<div class="sunset-sun"></div>' +
        '<svg class="sunset-ridge sunset-ridge--far" viewBox="0 0 1400 320" preserveAspectRatio="none">' +
          '<path d="M0 320V150l110-58 90 40 140-96 120 74 110-50 150 84 130-66 140 58 100-40 110 52 100-36 100 44V320z"/>' +
          '<path class="snow" d="M340 92l140-96 70 48-40 10-32-28-56 58zM900 122l130-66 60 44-28 8-34-28-56 48z"/>' +
        '</svg>' +
        '<svg class="sunset-ridge sunset-ridge--near" viewBox="0 0 1400 320" preserveAspectRatio="none">' +
          '<path d="M0 320V210l150-78 120 58 160-108 140 90 130-54 170 96 150-80 160 70 120-44 100 50V320z"/>' +
        '</svg>';
      host.insertBefore(sc, host.firstChild);
    },
    stars: function (host) {
      var sc = el("div", "scene scene--stars");
      var n = window.innerWidth < 760 ? 30 : 60;
      for (var i = 0; i < n; i++) {
        var st = el("span", "star");
        st.style.setProperty("--x", (Math.random() * 100).toFixed(1) + "%");
        st.style.setProperty("--y", (Math.random() * 70).toFixed(1) + "%");
        st.style.setProperty("--sz", (1 + Math.random() * 2).toFixed(1) + "px");
        st.style.setProperty("--tw", (2.5 + Math.random() * 4).toFixed(1) + "s");
        st.style.setProperty("--delay", (-Math.random() * 6).toFixed(1) + "s");
        sc.appendChild(st);
      }
      host.insertBefore(sc, host.firstChild);
    }
  };
  [].slice.call(document.querySelectorAll("[data-scene]")).forEach(function (host) {
    var fn = scenes[host.getAttribute("data-scene")];
    if (fn) fn(host);
  });

  /* ============ 3b. Let the footer flow into a dark section directly above it ============ */
  var footer = document.querySelector(".site-footer");
  if (footer) {
    var main = document.getElementById("MainContent");
    var lastSection = main ? main.lastElementChild : null;
    /* Shopify wraps sections in <div class="shopify-section"> — check the wrapper and its last child */
    var dark = null;
    if (lastSection) {
      if (lastSection.classList.contains("section--dark")) dark = lastSection;
      else if (lastSection.lastElementChild && lastSection.lastElementChild.classList.contains("section--dark")) dark = lastSection.lastElementChild;
    }
    if (dark) { footer.classList.add("site-footer--merge"); dark.classList.add("is-before-footer"); }
  }

  /* ============ 4. 3D tilt (cards, frames, lift pass) ============ */
  if (finePointer && !reduced) {
    var tilts = [].slice.call(document.querySelectorAll("[data-tilt]"));
    tilts.forEach(function (el) {
      el.classList.add("tilt");
      var max = parseFloat(el.getAttribute("data-tilt")) || 7;
      if (!el.querySelector(".tilt__glare")) {
        var g = document.createElement("span");
        g.className = "tilt__glare";
        el.appendChild(g);
      }
      var raf = null, rx = 0, ry = 0, gx = 50, gy = 50;
      function paint() {
        raf = null;
        el.style.transform = "perspective(900px) rotateX(" + rx.toFixed(2) + "deg) rotateY(" + ry.toFixed(2) + "deg) translateZ(6px)";
        el.style.setProperty("--gx", gx.toFixed(1) + "%");
        el.style.setProperty("--gy", gy.toFixed(1) + "%");
      }
      el.addEventListener("pointerenter", function () {
        el.classList.add("is-tilting");
        el.style.transition = "transform 0.15s ease-out";
      });
      el.addEventListener("pointermove", function (e) {
        var r = el.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width;
        var py = (e.clientY - r.top) / r.height;
        ry = (px - 0.5) * max * 2;
        rx = (0.5 - py) * max * 2;
        gx = px * 100; gy = py * 100;
        if (!raf) raf = requestAnimationFrame(paint);
      });
      el.addEventListener("pointerleave", function () {
        el.classList.remove("is-tilting");
        el.style.transition = "transform 0.7s cubic-bezier(0.16, 1, 0.3, 1)";
        el.style.transform = "perspective(900px) rotateX(0deg) rotateY(0deg) translateZ(0)";
      });
    });
  }

  /* ============ 5. Lift pass: live season label ============ */
  var season = document.querySelector("[data-season]");
  if (season) {
    var now = new Date(); var y = now.getFullYear();
    var start = now.getMonth() >= 8 ? y : y - 1;       // season runs Sep → Aug
    season.textContent = String(start).slice(2) + "/" + String(start + 1).slice(2);
  }
})();
